'use client';

const ScrollToContactButton = ({ label }: { label: string }) => {
	const handleClick = () => {
		document
			.getElementById('feedback-form')
			?.scrollIntoView({ behavior: 'smooth' });
	};
	return (
		<button className="btn btn-accent px-6 py-2" onClick={handleClick}>
			{label}
		</button>
	);
};
export default ScrollToContactButton;

